__turbopack_context__.v({
  "box": "global-loader-module__US9dJW__box",
  "box1": "global-loader-module__US9dJW__box1",
  "box2": "global-loader-module__US9dJW__box2",
  "box3": "global-loader-module__US9dJW__box3",
  "box4": "global-loader-module__US9dJW__box4",
  "boxes": "global-loader-module__US9dJW__boxes",
});
